import { render, staticRenderFns } from "./FooterCopyright.vue?vue&type=template&id=5dfbc755"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"
import style0 from "./FooterCopyright.vue?vue&type=style&index=0&id=5dfbc755&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports